import { PHONE_DATA_BY_COUNTRY_ISO } from 'www/vue_components/common/mixins/CountryData/constants'
import { getPhoneOptions } from 'www/vue_components/common/mixins/CountryData/functions'

export default {
  name: 'CountryData',
  data() {
    const countryIso = window.COUNTRY_DATA.iso || ''
    const phoneDataByCountryIso = PHONE_DATA_BY_COUNTRY_ISO[countryIso.toLowerCase()]

    if (!countryIso) {
      return {
        country: null,
      }
    }

    if (!phoneDataByCountryIso) {
      return {
        country: { iso: countryIso },
      }
    }

    const { code } = window.COUNTRY_DATA.phone
    const {
      masks,
      tokens,
      formattedMasks,
      regexps,
    } = getPhoneOptions(phoneDataByCountryIso, code)

    return {
      country: {
        iso: countryIso,
        phone: {
          minLength: window.COUNTRY_DATA.phone.minLength,
          maxLength: window.COUNTRY_DATA.phone.maxLength,
          code,
          maskOptions: {
            mask: masks,
            tokens,
          },
          formattedMasks,
          regexps,
        },
      },
    }
  },
}
